import React from "react";
import { default as MUITypography } from "@mui/material/Typography";
import styled from "styled-components";

const StyledMUITypography = styled(MUITypography)``;

export const Typography = (props) => {
  return <StyledMUITypography {...props} />;
};
